import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { EventSettings, EventSettingsUpdate } from '@/types/eventSettings'

export const eventSettingsQueryKey = ['event-settings'] as const

export function useEventSettings() {
  return useQuery<EventSettings>({
    queryKey: eventSettingsQueryKey,
    queryFn: async () => {
      const res = await api.get<EventSettings>('/event-settings')
      return res.data
    },
  })
}

export function useUpdateEventSettings() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (payload: EventSettingsUpdate) => {
      const res = await api.patch<EventSettings>('/event-settings', payload)
      return res.data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: eventSettingsQueryKey })
    },
  })
}
